import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import LoaderModule from './modules/loader'
import userModule from './modules/user'
import authModule from './modules/auth'
import testsModule from './modules/tests'
import CountriesModule from './modules/countries'
import RechargeModule from './modules/recharge'
import CompetitorModule from './modules/competitor'
import IcgModule from './modules/icg'

Vue.use(Vuex)

const vuexPersist = new VuexPersistence({
  strictMode: process.env.NODE_ENV !== 'production',
  storage: window.localStorage,
  key: 'routing-tool',
  asyncStorage: false,
  modules: ['countries', 'tests'],
  reducer: (state) => ({
    'countries': state.countries,
    'tests': state.tests,
    'auth': state.auth
  })
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [vuexPersist.plugin],
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION
  },
  modules: {
    'user': userModule,
    'auth': authModule,
    'tests': testsModule,
    'countries': CountriesModule,
    'loader': LoaderModule,
    'recharge': RechargeModule,
    'competitor': CompetitorModule,
    'icg': IcgModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js